exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes expand {\n  0% {\n    width: 0%; }\n  100% {\n    width: 100%; } }\n\n.metrica {\n  text-transform: uppercase;\n  color: #565656;\n  padding: 7px;\n  font-size: 18px;\n  text-align: center; }\n  .metrica > div:first-child {\n    float: left;\n    font-weight: bold; }\n  .metrica > div:nth-of-type(2) {\n    float: right;\n    font-weight: bold; }\n  .metrica .bar {\n    height: 5px;\n    background-color: #f1f1f1;\n    margin-top: 10px;\n    clear: both; }\n    .metrica .bar .inner-bar-container {\n      position: relative;\n      left: 0; }\n      .metrica .bar .inner-bar-container .inner-bar {\n        height: 5px;\n        animation-name: expand;\n        animation-duration: 1.2s; }\n\n.green {\n  background-color: #4BB08A; }\n\n.orange {\n  background-color: #F29837; }\n\n.red {\n  background-color: #E32116; }\n\n@media (max-width: 1470px) {\n  .metrica {\n    font-size: 15px; } }\n\n@media (max-width: 1230px) {\n  .metrica {\n    font-size: 12px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/metrica/metrica.scss
// module id = ../../../../../src/app/components/common/metrica/metrica.scss
// module chunks = 0